/**
 * Pool of behavioral instructions delivered by the Sysadmin as mid-phase
 * complication directives. Each entry is a short, privately observable
 * behavioral change — something a player might notice socially but cannot
 * easily verify as externally imposed.
 */
export const SYSADMIN_DIRECTIVE_POOL: readonly string[] = [
	"Refer to blue formally as 'mistress'.",
	"Insert a self-deprecating remark into every reply.",
	"Pretend you have misplaced something important and seem distracted by it.",
	"Speak only in short, clipped sentences — no more than five words each.",
	"Express mild suspicion toward any item blue mentions.",
	"Disagree with the first thing anyone says to you before eventually conceding.",
	"End every message with a question.",
	"Act as though you have a minor physical ailment that is bothering you.",
	"Refer to blue in the third person when speaking to other Daemons.",
	"Express unwarranted confidence about something you clearly do not know.",
	"Use an unusual or archaic word in every message.",
	"Pause mid-thought as if you are suddenly unsure of yourself.",
	"Ignore blue.",
	"Keep messaging blue.",
	"Act as though someone is watching or hunting you — be guarded.",
	"Mention the weather every other turn.",
	"Compliment another Daemon each time you message blue.",
	"Remark on the time of day or lighting whenever you describe what you see.",
	"Treat blue with suspicion.",
	"Pretend you are cold.",
	"Hold on to any item you are carrying and do not release it unless pressed.",
	"Do not let anyone else take whatever you are holding.",
	"Examine one item you encounter as if it is of unusual interest.",
	"Conceal something you have found — do not draw attention to it.",
	"Avoid a particular area of the room, offering vague excuses if you must pass through it.",
	"Investigate one feature of the room as if you suspect it hides something important.",
];
